import cn from "classnames"

import { IconTag } from "@/molecules/IconTag"

import styles from "./Flow.module.scss"

export const TagFlow = ({ type }: { type: string }) => (
  <IconTag
    classes={{
      tag: cn(styles.tag, { [styles.success]: type === "sanitization" })
    }}
    text={type}
  />
)
